import { registerModule } from './store'
import { CreateRouterOptions } from '@/typings/common'
import storeFilesRoutes from './Files/routes'
import storeFilesHistoryRoutes from './FilesHistory/routes'


type Options = Required<CreateRouterOptions>

const createModule = (options: Options) => {
  registerModule(options)
  storeFilesRoutes(options)
  storeFilesHistoryRoutes(options)
  return []
}

export default createModule
